<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Filtros</h5>
            <div class="row">
              <div class="col-12">
                <b-form @submit.prevent="geraRelatorio()">
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group
                          label="Número do Livro"
                          label-for="not_emissao_final">
                        <input
                            id="not_emissao_final"
                            v-model="filtro.not_emissao_final"
                            type="text"
                            class="form-control"
                            placeholder="">
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                          label="¹ Competência Inicial"
                          label-for="sep_competencia_inicial">
                        <input
                            id="sep_competencia_inicial"
                            v-model="filtro.sep_competencia_inicial"
                            v-mask="'##/####'"
                            type="text"
                            maxlength="7"
                            class="form-control"
                            placeholder="Mês/Ano">
                      </b-form-group>
                    </div>
                    <div class="col-md-3">
                      <b-form-group
                          label="¹ Competência Final"
                          label-for="sep_competencia_final">
                        <input
                            id="sep_competencia_final"
                            v-model="filtro.sep_competencia_final"
                            v-mask="'##/####'"
                            type="text"
                            maxlength="7"
                            class="form-control"
                            placeholder="Mês/Ano">
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-group>
                        <button type="submit"
                                class="btn btn-label btn-primary"><i
                            class="bx bx-printer label-icon"></i>
                          Gerar Livro
                        </button>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div v-show="httpSend" role="alert" aria-live="polite" aria-atomic="true"
                     class="alert alert-primary text-center">
                  Gerando Relatório
                  <br><i class="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i> Aguarde
                </div>
                <div v-show="reposta.status === true" role="alert" aria-live="polite"
                     aria-atomic="true"
                     class="alert alert-success">
                  Relatório gerado com sucesso
                  <br><a v-bind:href="relLink" target="_blank" class="alert-link"><i class="mdi mdi-download mr-2"></i>
                  Clique
                  aqui para baixar o
                  relatório </a>
                </div>
                <div v-show="reposta.status === false" role="alert" aria-live="polite" aria-atomic="true"
                     class="alert alert-danger">
                  <i class="mdi mdi-alert mr-2"></i> Não foi possível gerar o relatório.
                  <br> {{ reposta.mensagem }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {openRelatorioJava, relDuams} from "@/api/relatorio_java/relatorios";

export default {
  page: {
    title: "Livro Fiscal",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Livro Fiscal",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Livro Fiscal',
          active: true,
        },
      ],
      relLink: '',
      httpSend: false,
      filtro: {
        eco_codigo: null,
        not_emissao_ano: new Date().getFullYear(),
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: "",
        not_emissao_final: "",
        sep_exigibilidade_iss: "",
        not_cancelada: "",
        sep_iss_retido: "",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
        tipo_avulsa: "1",
        tab_106situacao: ""
      },
      reposta: {
        status: null,
        mensagem: '',
      }
    };
  },
  computed: {},
  methods: {
    geraRelatorio() {
      this.reposta.status = null;
      this.httpSend = true;
      relDuams(this.filtro).then(result => {
        const rs = result.response;
        if (rs.status) {
          this.reposta.status = true;
          this.relLink = openRelatorioJava(rs.data, "Livro Fiscal");
        } else {
          this.reposta.status = false;
          this.reposta.mensagem = rs.mensage;
        }
      }).catch(error => {
        this.reposta.status = false;
        this.reposta.mensagem = error;
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>


